//=require ../bower_components/jquery/dist/jquery.min.js
//=require ../bower_components/isotope/dist/isotope.pkgd.min.js
//=require ../bower_components/perfect-scrollbar/js/perfect-scrollbar.jquery.min.js
//=require ../bower_components/owl.carousel/dist/owl.carousel.min.js
//=require ../bower_components/Hyphenator/Hyphenator.js
//=require ../bower_components/jquery-ui/ui/widget.js
//=require ../bower_components/jquery-ui/ui/widgets/mouse.js
//=require ../bower_components/jquery-ui/ui/widgets/slider.js
//=require ../bower_components/jQuery-ui-Slider-Pips/dist/jquery-ui-slider-pips.min.js
//=require ../bower_components/jquery-form/jquery.form.js
//=require ../node_modules/jquery-lazyload/jquery.lazyload.js
//=require js/ma.js
